var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('vue-editor',{on:{"change":_vm.changeProp},model:{value:(_vm.field.params.html),callback:function ($$v) {_vm.$set(_vm.field.params, "html", $$v)},expression:"field.params.html"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }